"use strict";
exports.__esModule = true;
exports.User = exports.withFeatureFlaggingSetup = exports.createFeatureFlaggingProvider = exports.useBooleanFeatureFlag = exports.FeatureFlaggingForUser = void 0;
var Provider_1 = require("./Provider");
exports.FeatureFlaggingForUser = Provider_1.FeatureFlaggingForUser;
exports.useBooleanFeatureFlag = Provider_1.useBooleanFeatureFlag;
exports.createFeatureFlaggingProvider = Provider_1.createFeatureFlaggingProvider;
exports.withFeatureFlaggingSetup = Provider_1.withFeatureFlaggingSetup;
var ub_feature_flagging_core_1 = require("ub-feature-flagging-core");
exports.User = ub_feature_flagging_core_1.User;
